import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';

import { AuthService, UserService } from '@/services';

import { persistedAuthReducer } from './reducers/Auth';
import { initAuthTokensSync } from './authTokensSync';
import { servicesReducers, servicesMiddlewares } from './servicesReducer';
import { deferApiRegistrationMiddleware } from './deferApiRegistrationMiddleware';
import { resetApiCachesOnAuthChange } from './resetApiCachesOnAuthChange';
import { persistedCallQueueReducer } from '@/pages/AttendTrack/pages/Monitors/reducers';
import { monitorMiddleware } from '@/pages/AttendTrack/pages/Monitors/middleware/monitorMiddleware';

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    callQueue: persistedCallQueueReducer,
    [AuthService.reducerPath]: AuthService.reducer,
    [UserService.reducerPath]: UserService.reducer,
    ...servicesReducers,
  },
  devTools: false,
  // @ts-ignore
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(
      deferApiRegistrationMiddleware,
      AuthService.middleware,
      UserService.middleware,
      ...servicesMiddlewares,
      monitorMiddleware,
      resetApiCachesOnAuthChange
    ),
});

export const persistor = persistStore(store);

initAuthTokensSync(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
